import { EnvironmentVariables, getEnvironmentVariable } from '@Services/env/environment.service.ts';
import type { AnyFunction, TimeoutId } from '@Types/util.ts';

export const isEmbedded = () => window.self !== window.top;

export const debounce = function <T extends AnyFunction>(func: T, delay = 500) {
  let timeoutId: TimeoutId;

  return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

export const redirectToWebAppLoginPage = (email?: string) => {
  const redirectUrl = getEnvironmentVariable(EnvironmentVariables.VITE_APP_DEEPLINK);
  window.location.replace(
    email ? `${redirectUrl}?email=${encodeURIComponent(email)}` : redirectUrl
  );
};

export const typedObjectKeys = <T extends object>(obj: T) => {
  return Object.keys(obj) as (keyof T)[];
};

export const typedObjectValues = <T extends object>(obj: T) => {
  return Object.values(obj) as T[keyof T][];
};
